// @flow
import type { DiamondType } from '@types/diamond';

import {
  shapeProngImagePath,
  fullSizeShapeImagePath,
  compareDiamondDimensions
} from '@src/utils/images';

const yellowGoldBand = '/images/goldring.jpg';
const whiteGoldBand = '/images/white_goldring.jpg';
const platinumBand = '/images/platinumring.jpg';

export function compareSizeDiamond (diamond: DiamondType) {
  return (
    <img
      src={fullSizeShapeImagePath(diamond)}
      {...compareDiamondDimensions(diamond)}
    />
  );
}

type OptionsType = {
  scale?: number,
  ring?: string
};

// Can scale down to reuse image in other places
// Used in cart and emails so need full image paths
export function diamondRing (diamond: DiamondType, options: OptionsType = {}) {
  const scale = options.scale || 1;
  const ring = options.ring
    ? `${options.ring.replace(/\s-/g, '_').toLowerCase()}ring`
    : 'goldring';
  const rockHeight = Math.round(diamond.measure_length * 11) * scale;
  const rockWidth = Math.round(
    parseFloat(rockHeight) / diamond.length_width_ratio
  );
  let ringWidth;
  let ringImage;

  // goldring.jpg width was trimmed to 244 as it was too wide on diamond show page
  if (ring === 'goldring') {
    ringWidth = Math.round(244 * scale);
  } else {
    ringWidth = Math.round(276 * scale);
  }

  switch (ring) {
    case 'goldring':
      ringImage = yellowGoldBand;
      break;
    case 'white_goldring':
      ringImage = whiteGoldBand;
      break;
    case 'platinum_ring':
      ringImage = platinumBand;
      break;
  }

  const ringHeight = Math.round(258 * scale);
  const heightBuffer = scale === 1 ? 11 : -1;
  const rockTop = `-${Math.round(
    ringHeight / 2 - heightBuffer + rockHeight / 2
  )}px`;
  const rockLeft = `${Math.round(ringWidth / 2 - rockWidth / 2)}px`;
  // 0.3 = 41x35
  // center of diamond should be 140 from left and 118 from bottom

  return (
    <div>
      <div style={{ zIndex: 1 }} className="presentation">
        <img
          id="ringColorImage"
          src={ringImage}
          style={{
            width: `${ringWidth}px`,
            height: `${ringHeight}px`,
            border: 0
          }}
        />
      </div>
      <div
        style={{
          position: 'relative',
          zIndex: 2,
          top: rockTop,
          left: rockLeft
        }}
        className="diamondIMG">
        <img
          src={shapeProngImagePath(diamond)}
          style={{
            border: 0,
            width: `${rockWidth}px`,
            height: `${rockHeight}px`
          }}
        />
      </div>
    </div>
  );
}
